import { PropTypes } from 'prop-types'
import { Paper } from '@material-ui/core'
import React from 'react'
import { Link } from 'react-router-dom'

export default function MsgScreen({ msg }) {


    setTimeout(() => {
        window.document.getElementById('msgBox').scrollIntoView()
    }, 200)
    setTimeout(() => {
        window.document.getElementById('msgBox').scrollIntoView()
    }, 1000)

    const urlMsg = window.location.href.split('MsgScreen/').length > 0 ?
        unescape(window.location.href.split('MsgScreen/')[1]) : '';


    // const y = window.document.getElementById('msgBox')?.getBoundingClientRect().top;
    // // if (window.scrollY) {
    // window.scroll(0, y);
    // // }

    // useEffect(() => {
    //     if (urlMsg.length > 0) {

    //         window.document.getElementById('divMsg').innerHTML = unescape(urlMsg[1])
    //         //  {__html: props.text}
    //         //  {React.createElement(this.props.tag, {children: <content>, prop1: <v1>, ...})}
    //     }

    // }, [])


    return (
        <div id='msgBox' style={{ paddingTop: '1rem' }}>


            <Paper style={{
                width: '90%',
                margin: '7rem auto',
                padding: '7rem'
            }}
            >
                <Link to='/'>Home</Link>
                {unescape(msg)}

                <h1 >{urlMsg}</h1>

                {/* <div id='divMsg'>
                    {urlMsg.length > 0 &&
                        <h1>{unescape(urlMsg[1])}</h1>
                    }
                </div> */}

                <img src='https://i1.wp.com/boingboing.net/wp-content/uploads/2015/07/unicorn_riding_rainbow_by_k_rui-d3lmuln.gif?resize=343%2C276'
                    style={{
                        margin: '0 auto',
                        display: 'block'
                    }} />
            </Paper>

        </div >
    )
}
MsgScreen.propTypes = {
    msg: PropTypes.string,
}